module.exports = __webpack_public_path__ + "img/jetaqsaat-logo.6280d5d6.png";